import { useTranslation } from 'react-i18next';
import type { TFunction } from 'i18next';
import { isExtraHold, isScannedHold } from './geometry';

/**
 * Where a hold sits on the wall, in the terms it can be found by.
 *
 * Three kinds of wall, three ways of saying it. On a ruled wall a hold is a row
 * and a column. On one drawn as lines the row *is* the line and the column is
 * how far along it, so it is said that way — "line 3, hold 5" is something a
 * setter can go and point at, "row 3, column 5" is not. A hold off the grid has
 * neither: its "column" is the id the board files it under.
 */
export function cellName(
  t: TFunction,
  cell: { row: number; col: number },
  shaped = false
): string {
  if (isExtraHold(cell.row)) return t('climbs.board.extraCell', { id: cell.col + 1 });
  if (isScannedHold(cell.row)) return t('climbs.board.scannedCell', { id: cell.col + 1 });

  return shaped
    ? t('climbs.board.lineCell', { line: cell.row + 1, hold: cell.col + 1 })
    : t('climbs.board.cell', { row: cell.row + 1, col: cell.col + 1 });
}

/** cellName, for the components that have no `t` of their own to hand. */
export function useCellName(cell: { row: number; col: number }, shaped = false): string {
  const { t } = useTranslation();

  return cellName(t, cell, shaped);
}
